import { Theme } from '@mui/material/styles';

import { Page } from '@/components/Layout/Page/Page';
import { OnboardingGuide } from '@/components/OnboardingGuide';
import { LanguageSelectionForm } from '@/components/PageForm/LanguageSelectionForm';

import { useResponsive } from '@/hooks/useResponsive';

import { PROGRESS_STEPS } from '@/utils/progressSteps';

export function LanguageSelectionPage() {
  const { isMobile } = useResponsive();
  return (
    <Page
      paperProps={{
        color: (theme: Theme) => theme.palette.neutral[1000],
        position: 'right',
        size: 'big',
        children: isMobile ? null : <OnboardingGuide />,
      }}
      progressProps={PROGRESS_STEPS.languageStep}
      hasLogo
    >
      <LanguageSelectionForm />
    </Page>
  );
}
export default LanguageSelectionPage;
